<app-dialog-container
  [title]="data.title"
  [confirmButtonText]="data.confirmButtonText"
  [confirmButton]="data.confirmButton"
  [cancelButtonText]="data.cancelButtonText"
>
  <mat-dialog-content class="content-container">
    @if (data.content) {
      <ng-container *ngTemplateOutlet="data.content"></ng-container>
    } @else {
      <p>
        {{ data.message | translate: { entityName: data.entityName } }}
        @if (!data.ownPunctuationMark) {
          <span>{{ data.list?.length ? ':' : '.' }}</span>
        }
      </p>
      @if (data.list?.length && data.entityType) {
        <p>
          {{
            'ifYouConfirmRemovalSparePartsBackInStock'
              | translate: { entityType: data.entityType | translate }
          }}
        </p>
        <ul>
          @for (item of data.list; track item) {
            <li>{{ item }}</li>
          }
        </ul>
      }
      @if (data.warningMessage) {
        <div class="warning-message-container-confirm-dialog">
          <mat-icon class="warning-icon-confirm-dialog">warning</mat-icon>
          <p class="warning-message-confirm-dialog">
            {{ data.warningMessage | translate }}
          </p>
        </div>
      }
      @if (data.showAreYouSure) {
        <p>{{ 'areYouSure' | translate }}?</p>
      }
    }
  </mat-dialog-content>
</app-dialog-container>
